function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M93.5 96H197.5C210.755 96 221.5 85.2548 221.5 72C221.5 58.7452 210.755 48 197.5 48C195.918 48 194.371 48.1531 192.874 48.4454C193.282 47.034 193.5 45.5425 193.5 44C193.5 35.1634 186.337 28 177.5 28C172.704 28 168.4 30.1105 165.468 33.4536C165.489 32.9717 165.5 32.4871 165.5 32C165.5 14.3269 151.173 0 133.5 0C115.827 0 101.5 14.3269 101.5 32C101.5 32.3386 101.505 32.6761 101.516 33.0122C98.954 32.3515 96.2681 32 93.5 32C75.8269 32 61.5 46.3269 61.5 64C61.5 81.6731 75.8269 96 93.5 96Z",
  fill: "#D6EBFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M244.5 84C244.5 86.9143 243.721 89.6466 242.359 92H248.5C257.337 92 264.5 99.1634 264.5 108C264.5 116.837 257.337 124 248.5 124H160.5C147.245 124 136.5 113.255 136.5 100C136.5 86.7452 147.245 76 160.5 76C160.5 58.3269 174.827 44 192.5 44C207.676 44 220.385 54.5647 223.673 68.741C225.196 68.2596 226.818 68 228.5 68C237.337 68 244.5 75.1634 244.5 84Z",
  fill: "#99CEFF"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 119.5,
  y: 97,
  width: 28,
  height: 35,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M96.5 136H24.5H20.5V135.668C9.14915 133.764 0.5 123.892 0.5 112C0.5 98.7452 11.2452 88 24.5 88C27.622 88 30.6047 88.5961 33.3406 89.6807C36.1143 79.4917 45.4323 72 56.5 72C67.2562 72 76.3597 79.0759 79.4097 88.8268C81.0087 88.2905 82.7204 88 84.5 88C93.3366 88 100.5 95.1634 100.5 104C100.5 104.168 100.497 104.335 100.492 104.502C107.397 106.276 112.5 112.542 112.5 120C112.5 128.837 105.337 136 96.5 136Z",
  fill: "#C2E1FF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M145.5 80V72C145.5 65.3726 140.127 60 133.5 60C126.873 60 121.5 65.3726 121.5 72V80H145.5ZM133.5 48C120.245 48 109.5 58.7452 109.5 72V92H157.5V72C157.5 58.7452 146.755 48 133.5 48Z",
  fill: "#47A6FF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M96.5 80C94.8431 80 93.5 81.3431 93.5 83V141C93.5 142.657 94.8431 144 96.5 144H170.5C172.157 144 173.5 142.657 173.5 141V83C173.5 81.3431 172.157 80 170.5 80H96.5ZM141.5 108C141.5 110.961 139.891 113.547 137.5 114.93V120C137.5 122.209 135.709 124 133.5 124C131.291 124 129.5 122.209 129.5 120V114.93C127.109 113.547 125.5 110.961 125.5 108C125.5 103.582 129.082 100 133.5 100C137.918 100 141.5 103.582 141.5 108Z",
  fill: "#0067C5"
});

function SvgAccessDenied(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 144,
    viewBox: "0 0 265 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/AccessDenied.ac5aa9c2220e9c4bc1c35918f7983b9c.svg";
export { ForwardRef as ReactComponent };